import { OnInit, Component, Inject, ChangeDetectorRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TenantTemplatePickerComponent } from "../media/tenant-template-picker/tenant-template-picker.component";
import { TenantTemplate } from "src/app/setting/template/template.model";
import { DistributionChannelEmail, DistributionChannelSms, EntityDataType, MediaModel, MediaSourceType, VoucherTemplateLimitation, VoucherTemplateLocation } from "src/app/common/media.model";
import { WalletBarcodeType } from "src/app/common/wallet-barcode-type.enum";
import { isNullOrUndefined } from 'src/app/common/functions';
import { MediaService } from "src/app/shared/media.service";
import { catchError, lastValueFrom, map, Observable, of } from "rxjs";
import { SavingDialogComponent } from "src/app/common/saving-dialog.component";
import { Globals } from "src/app/common/globals";
import { ErrorDialogComponent } from "src/app/common/dialog.error.component";
import { TranslationService } from "src/app/shared/translation.service";
import { InfoDialogComponent } from "src/app/common/dialog.info.component";
import { ConfigurationService } from "src/app/shared/configuration.service";
import { Honeycomb } from "src/app/shared/honeycomb-api/honeycomb-api";
import { MediaDetailValidator } from "../media/media-detail-validator";
import { AppleWalletPassStyle, GoogleWalletPassStyle } from "src/app/common/wallet-passstyle-enum";

@Component({
    selector: 'hc-digital-cards-create',
    templateUrl: './digital-cards-create.component.html',
    styleUrls: ['./digital-cards-create.component.scss']
})

export class DigitalCardsCreateComponent implements OnInit {

    GoogleWalletPassStyle = GoogleWalletPassStyle;
    AppleWalletPassStyle = AppleWalletPassStyle;

    public model: MediaModel;

    public mediaModel: MediaModel = new MediaModel();

    public groups: Observable<string[]>;

    private errors: any[] = [];
    //public service: MediaService;

    private voucherTemplateCreation = false;
    private tenantTemplateSelected = false;
    public voucherTemplateData: TenantTemplate = null;

    public walletStyleGoogleOptions: number[] = Object
        .keys(GoogleWalletPassStyle)
        .filter(k => !isNaN(Number(GoogleWalletPassStyle[k as any])))
        .map(k => (GoogleWalletPassStyle as any)[k])
        .filter(v => v === GoogleWalletPassStyle.Generic || v === GoogleWalletPassStyle.LoyaltyCard || v === GoogleWalletPassStyle.Offer) as number[];

    public walletStyleAppleOptions: number[] = Object
        .keys(AppleWalletPassStyle)
        .filter(k => !isNaN(Number(AppleWalletPassStyle[k as any])))
        .map(k => (AppleWalletPassStyle as any)[k])
        .filter(v => (v == AppleWalletPassStyle.StoreCard) || (v == AppleWalletPassStyle.EventTicket)) as number[];

    public selectedGoogleWalletStyle: number = GoogleWalletPassStyle.Generic;
    public selectedAppleWalletStyle: number = AppleWalletPassStyle.EventTicket;
    public createAttempted = false;

    walletTypes = ['Typ A', 'Typ B'];
    mediaTemplates = ['Šablona 1', 'Šablona 2'];

    constructor(
        private dialogRef: MatDialogRef<DigitalCardsCreateComponent>,
        private dialog: MatDialog,
        private mediaService: MediaService,
        private cd: ChangeDetectorRef,
        private globals: Globals,
        private trans: TranslationService,
        private configurationService: ConfigurationService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject('VoucherTemplatesController') private voucherTemplatesController: Honeycomb.Tenant.Vouchers.IService.VoucherTemplatesController,
        @Inject('WalletTemplateController') private templateController: Honeycomb.Tenant.TemplateEngine.IService.WalletTemplateController,
    ) {}


    ngOnInit(): void {
        this.model = new MediaModel();
        this.model.distributionChannelEmail = new DistributionChannelEmail();
        this.model.distributionChannelSms = new DistributionChannelSms();
        this.model.mediaSourceType = MediaSourceType.TenantTemplates;
        this.model.walletBarcodeType = WalletBarcodeType.Code128;
        
        this.setupWalletInfos();
        this.model.useTemplateData = this.model.entityDataType === EntityDataType.Voucher ||
            this.model.entityDataType === EntityDataType.User;
        this.model.initialized = true;
        this.groups = this.mediaService.getGroups();
    }

    public async selectTenantTemplate() {
        let dialogRef = this.dialog.open(TenantTemplatePickerComponent, {
            data: {}
        });
        let changeTemplateResult = await dialogRef.afterClosed().toPromise();
        if (!changeTemplateResult) { return; }

        let templateType = <TenantTemplate>changeTemplateResult;

        this.model.tenantTemplateName = templateType.name;
        this.model.tenantTemplateDescription = templateType.description;
        this.model.tenantTemplateCaption = templateType.caption;
        this.model.tenantTemplateExists = true;
        this.model.tenantTemplateID = templateType.tenantTemplateTypeID;
        // load params / styles detail
        let template = await this.mediaService.getTemplate(templateType.tenantTemplateTypeID).toPromise();

        if (template.entityDataType == EntityDataType.Voucher)
        {
            this.voucherTemplateCreation = true;
            this.voucherTemplateData = template;
        }

        this.model.mediaParameters = template.tenantTemplateParameters.map((m => { m.value = m.value || m.defaultValue; return m; }));
        this.model.mediaStyles = template.tenantTemplateStyles.map((m => { m.value = m.value || m.defaultValue; return m; }));

        this.tenantTemplateSelected = true;

        if (!this.cd['destroyed']) { this.cd.detectChanges(); }

        // if (!!this.detailMediaViewer) {
        //     this.detailMediaViewer.dataReady();
        // }
    }

    public setupWalletInfos() {
        if (isNullOrUndefined(this.model.walletInfos)) {
            this.model.walletInfos = [];
        }
        //this.walletAdditionalInfoDataSource = new WalletAdditionalInfoDataSource(this.model.walletInfos, this.walletAdditionalInfoSort);
        if (!this.cd['destroyed']) { this.cd.detectChanges(); }
    }

    async createMedia(){
        this.createAttempted = true;
        if (!this.isCreateDialogValid()) {
            if (!this.cd['destroyed']) { this.cd.detectChanges(); }
            return;
        }

        this.openCloak();

        this.errors = [];
        this.errors[0] = [];

        let isOk = await this.handleErrors();
        if(!isOk){
            this.closeCloak();
            return;
        }

        if (this.tenantTemplateSelected && this.voucherTemplateCreation) 
        {
            let newVoucherTemplate = new Honeycomb.Tenant.Vouchers.IService.Model.VoucherTemplate();
            
            newVoucherTemplate.name = this.model.description;
            newVoucherTemplate.useType = Honeycomb.Common.Enums.DiscountApplicationType.oneTime; // Not set not allowed

            this.model.voucherTemplateID  = await lastValueFrom(this.voucherTemplatesController.Post(newVoucherTemplate));
            this.voucherTemplateCreation = false;
        }

        this.fillMediadefaults();
        const appleWalletTemplate = this.getWalletTemplate(Honeycomb.Common.Enums.WalletTemplateTarget.apple);
        const appleWalletTemplateID = (await lastValueFrom(this.templateController.Post(<any>appleWalletTemplate))).walletTemplateID;
        const googleWalletTemplate = this.getWalletTemplate(Honeycomb.Common.Enums.WalletTemplateTarget.google);
        const googleWalletTemplateID = (await lastValueFrom(this.templateController.Post(<any>googleWalletTemplate))).walletTemplateID;

        this.model.walletGoogleTemplateID = googleWalletTemplateID;
        this.model.walletAppleTemplateID = appleWalletTemplateID;
        this.model.useWallet = true;
        //After all checks, saving media model
        let res = await lastValueFrom(this.mediaService.insertItem(this.model).pipe(
            catchError((e) => {
                this.dialog.open(InfoDialogComponent, { data: e });
                return null;
            })));

            this.closeCloak();
        if (res === null) {
            this.closeCloak();
            return false;
        }

        this.dialogRef.close(res);
    }

    public isCreateDialogValid(): boolean {
        return this.hasText(this.model?.walletTitle)
            && this.selectedGoogleWalletStyle != null
            && this.selectedAppleWalletStyle != null
            && this.hasText(this.model?.name)
            && this.hasText(this.model?.description)
            && this.hasText(this.model?.group)
            && !!this.model?.tenantTemplateID;
    }

    private hasText(value: string | null | undefined): boolean {
        return String(value ?? '').trim().length > 0;
    }
    
    //Media template dialog controlls
    save()  { this.dialogRef.close(this.model); }
    close() { this.dialogRef.close(null); }

    private cloakRef: MatDialogRef<SavingDialogComponent, any> = null;

    public closeCloak() {
        if (this.cloakRef !== null) {
            this.cloakRef.close();
            this.cloakRef = null;
        }
    }

    public openCloak() {
        if (this.cloakRef === null) {
            this.cloakRef = this.globals.saveDialog.open(SavingDialogComponent);
        }
    }

    private async handleErrors(): Promise<boolean>{
        let mediaCheck = await lastValueFrom(this.mediaService
            .checkName(this.model.description, null)
            .pipe(
                catchError(_ => of(false)),
                map(val => val !== false)));

        if (!mediaCheck) {
            this.dialog.open(ErrorDialogComponent, {
                data: {
                    message: this.trans.instant('admin.web.form-has-errors') + '<br/><br/>' +
                        this.trans.instant('admin.web.media-name-duplicit')
                }
            });
            this.errors[0].push(this.trans.instant('admin.web.media-name-duplicit'));
            this.closeCloak();
            if (!this.cd['destroyed']) { this.cd.detectChanges(); }
            return false;
        }

        let configCheck = await lastValueFrom(this.configurationService.checkName(this.model.description)
                .pipe(
                    catchError(_ => of(false)),
                    map(val => val !== false)));

        if (!configCheck) {
            this.dialog.open(ErrorDialogComponent, {
                data: {
                    message: this.trans.instant('admin.web.form-has-errors') + '<br/><br/>' +
                        this.trans.instant('admin.web.configuration-name-duplicit')
                }
            });
            if (!this.cd['destroyed']) { this.cd.detectChanges(); }
            this.closeCloak();
            return false;
        }
        return true;
    }

    private fillMediadefaults(){
        this.model.discountRelativeValueType = Honeycomb.Common.Enums.DiscountRelativeValueType.notSet;
        this.model.discountValidityRelative = null;
        this.model.discountValidityFixed = null;

        let validator = new MediaDetailValidator(this.model, this.trans);
        validator.Validate(true);
        let hasAnyError = validator.errors.filter(f => f.length > 0).length > 0;

        if (hasAnyError) {
            this.dialog.open(ErrorDialogComponent, {
                data: { message: this.trans.instant('admin.web.form-has-errors') + '<br/><br/>' + validator.getSummaryMessage() }
            });
            this.cd.detectChanges();
            this.closeCloak();
            return false;
        }

        this.model.walletInfos = [];

        if (this.model.voucherCategories != null &&  this.model.voucherCategories.length > 0) {
            let catLimits = this.model.voucherCategories.map(c => {
                let r = new VoucherTemplateLimitation();
                r.categoryID = c;
                return r;
            });
            this.model.voucherTemplateLimitations.push(...catLimits);
        }
        if (this.model.voucherWhiteListProductSets != null &&  this.model.voucherWhiteListProductSets.length > 0) {
            let prodLimits = this.model.voucherWhiteListProductSets.map(ps => {
                let r = new VoucherTemplateLimitation();
                r.productSetID = ps.productSetId;
                return r;
            });
            this.model.voucherTemplateLimitations.push(...prodLimits);
        }
        if (this.model.voucherBlackListProductSets != null &&  this.model.voucherBlackListProductSets.length > 0) {
            let prodLimits = this.model.voucherBlackListProductSets.map(ps => {
                let r = new VoucherTemplateLimitation();
                r.productSetID = ps.productSetId;
                return r;
            });
            this.model.voucherTemplateLimitations.push(...prodLimits);
        }
        this.model.voucherTemplateLocations = [];
        if (this.model.voucherLocations != null &&  this.model.voucherLocations.length > 0) {
            let locations = this.model.voucherLocations.map(ls => {
                let vtl = new VoucherTemplateLocation();
                vtl.locationID = ls;
                return vtl;
            });
            this.model.voucherTemplateLocations.push(...locations);
        }
    }

    private getWalletTemplate(target: number): Honeycomb.Tenant.TemplateEngine.IService.Model.WalletTemplate{
        let template = new Honeycomb.Tenant.TemplateEngine.IService.Model.WalletTemplate();
        template.name = this.model.name;
        template.description = this.model.description;
        template.target = target;
        template.walletStyle = target === Honeycomb.Common.Enums.WalletTemplateTarget.google
            ? this.selectedGoogleWalletStyle
            : this.selectedAppleWalletStyle;

        // Static wallet fields are enforced in detail save flow for backward compatibility.
        template.fields = [];

        return template;
    }
}